import { EntArea } from "./handBooks/area";
import { EntTypeProduct } from "./handBooks/typeProduct";

export class EntProduct {
  id: number = 0;
  productsTypeIds: number[]   | null = null;
  productsTypes: EntTypeProduct[]   | null = null;
  areaId: number | null = null;
  area: EntArea | null = null;
  countProduction: number   | null = null;
  countSales: number   | null = null;
}
